import React from "react";
import styles from "./styles/FormSectionContainer.module.css";
const FormSectionContainer = ({
  headerColor = "RGB(135, 175, 221)",
  title = "",
  index = 1,
  children,
}) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <div className={styles.container}>
        <div
          className={styles.heading}
          style={{
            backgroundColor: headerColor,
            display: "flex",
            alignItems: "center",
          }}
        >
          <h2 style={{ float: "left", marginLeft: 20 }}>{index}</h2>
          <h3>{title.toUpperCase()}</h3>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default FormSectionContainer;
